export default __webpack_public_path__ + "71cea7fc9828ea623d97255efef919dd.webp";